angular.module('charts')
  .directive('bubbleGraphModalTable', function() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: '/resources/charts/partials/bubble-graph-modal-table.html',
      controller: ['$scope', '$element', '$timeout', '$filter', 'tableColumns', '$state', function($scope, $element, $timeout, $filter, $tableColumns, $state) {
        $scope.visible = false;
        $scope.columns = $tableColumns.getColumns('bubbleGraph');

        var sortRowData = function () {
          if ($scope.rowData) {
            var params = $state.params;
            var order = (params.order === 'asc' ? '+' : '-');
            var sort = order + params.sort;
            var sorted = $filter('orderBy')($scope.rowData, sort);
            $scope.rowData = sorted;
          }
        };

        $scope.dismiss = function() {
          $element.find('.scroll-bar').each(function(index, item) {
            item.scrollTop = 0;
          });
          $scope.visible = false;
        };

        $scope.$on('bubbleClicked', function(e, cluster) {

          $timeout(function() {
            var $bubbleGraph = angular.element('bubble-graph');
            var graphHeight = parseInt($bubbleGraph.css('height'));
            var listTop = (graphHeight / 4);
            $scope.modalTop = listTop;
            $scope.modalMaxHeight = listTop * 2;

            $scope.visible = true;
            $scope.rowData = cluster.items;

          }, 100);
        });

        $scope.$on('updateSortableTable', sortRowData);

      }]
    };
  });
